import type { JoyEnvironment } from './env.config';

export const getAuthDomain = (env: JoyEnvironment): string => {
  switch (env) {
    case 'production':
    case 'stage':
      return 'auth.withjoy.com';
    case 'development':
    case 'local':
      return 'auth-dev.withjoy.com';
  }
};
